import { HttpError } from "@refinedev/core";
import { useTable } from "@refinedev/react-table";

import { DataTable } from "@/components/refine-ui/data-table/data-table";
import { DataTableActionBar } from "@/components/refine-ui/data-table/data-table-action-bar";
import { ListView } from "@/components/refine-ui/views/list-view";
import { usePerformanceColumns } from "@/pages/performances/hooks/use-columns";
import { IPerformanceData } from "@/types/performance";

export const PerformancesList = () => {
  const columns = usePerformanceColumns();

  const table = useTable<IPerformanceData, HttpError>({
    columns,
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    initialState: {
      columnVisibility: { id: false },
      columnPinning: { right: ["actions"] },
    },
    refineCoreProps: {
      meta: { defaultQueryBy: "_playTitle" },
      sorters: { initial: [{ field: "startDate", order: "desc" }] },
      pagination: { pageSize: 25 },
    },
  });

  return (
    <ListView>
      <DataTableActionBar resource="performances" table={table} />
      <DataTable table={table} />
    </ListView>
  );
};
